<template>
  <div class="col-12">
    <!--eslint-disable-next-line max-len-->
    <vue-headful :title="`${error.serialized.message} • ${$store.state.settings.settings.site_name}`" />
    <div class="row">
      <div class="col-md-6">
        <card>
          <template slot="header">
            <h4>{{ createdAtFormatted }}</h4>
            <h3 class="card-title">
              <i class="fa fa-user text-info mr-1" />
              {{ created_by }}
            </h3>
          </template>
          <el-table
            :data="userTableData">
            <el-table-column
              prop="ip"
              label="IP Address"
              :show-overflow-tooltip="true" />
            <el-table-column
              prop="user_agent"
              label="User Agent"
              :show-overflow-tooltip="true"
              :min-width="200" />
          </el-table>
        </card>
      </div>
      <div class="col-md-6">
        <card>
          <template slot="header">
            <h3 class="card-title">
              <i class="fa fa-paper-plane text-info mr-1" />
              Request Body
            </h3>
          </template>
          <vue-json-pretty
            :data="error.request.body"
            :show-line="false"
            :show-double-quotes="false" />
        </card>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <card>
          <template slot="header">
            <h3 class="card-title">
              <i class="fa fa-exclamation-triangle text-danger mr-1" />
              Error
            </h3>
          </template>
          <vue-json-pretty
            :data="error.serialized"
            :show-line="false"
            :show-double-quotes="false" />
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';
import moment from 'moment-timezone';

export default {
  name: 'ErrorDetail',
  components: {
    VueJsonPretty,
  },
  props: {
    error: {
      type: Object,
      required: true,
    },
  },
  computed: {
    created_by() {
      return this.error.created_by ? this.error.created_by.full_name : this.error.ip;
    },
    createdAtFormatted() {
      return moment(this.error.created_at).calendar();
    },
    userTableData() {
      return [{
        ip: this.error.ip,
        user_agent: this.error.request.user_agent,
      }];
    },
  },
};
</script>
